import React from 'react';
import FormSelect from 'shared/forms/FormSelect';
import { useGetChassisTypes } from 'src/fetch/equipmentType';

const ChassisTypeDropdown = (props) => {
  const { data: chassisTypes } = useGetChassisTypes();

  return (
    <FormSelect
      data={chassisTypes}
      textField="name"
      dataItemKey="id"
      {...props}
    />
  );
};

export default ChassisTypeDropdown;